import { useEffect, useRef } from "react";
import { heartbeatService } from "../services/heartbeatService";

export const useHeartbeat = (
  ticketId: number | string | undefined,
  status: string | undefined,
  intervalSeconds = 60
) => {
  const intervalIdRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    const ms = (Number(intervalSeconds) || 60) * 1000;

    const sendPing = async () => {
      if (
        !ticketId ||
        status !== "INICIADO" ||
        document.visibilityState !== "visible"
      ) {
        return;
      }

      try {
        const response: any = await heartbeatService.send(ticketId);
        
        if (response && [410, 404].includes(response.statusCode)) {
          const { code, message } = response;

          const event = new CustomEvent("ticket-expired", { 
            detail: { 
              ticketId, 
              code: code || "TICKET_INACTIVE", 
              message: message || "Sessão Expirada."
            } 
          });

          window.dispatchEvent(event);
          if (intervalIdRef.current) clearInterval(intervalIdRef.current);
        }

      } catch (error: any) {
        if (!error.message?.includes("Unexpected end of JSON input")) {
          console.error("[Heartbeat] Erro de rede ou servidor:", error.message);
        }
      }
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        sendPing();
      }
    };

    if (ticketId) {
      intervalIdRef.current = setInterval(sendPing, ms);

      document.addEventListener("visibilitychange", handleVisibilityChange);
      sendPing();
    }

    return () => {
      if (intervalIdRef.current) clearInterval(intervalIdRef.current);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [ticketId, status, intervalSeconds]);
};